<template>
  <div
    class="act004-form-scope"
    :class="{ 'act004-form-scope--survey': isSurveyLayout }"
    :style="viewportStyle"
    @click.stop
    @touchmove.stop
  >
    <div class="act004-form-scope__scroll" :style="scrollStyle">
      <!-- 问卷流式布局 -->
      <div v-if="isSurveyLayout" class="act004-form-scope__survey" :style="surveyContentStyle">
        <img
          v-if="bgUrl"
          class="act004-form-scope__bg act004-form-scope__bg--survey"
          :src="bgUrl"
          alt=""
        />
        <div class="act004-form-scope__survey-inner">
          <div v-if="introText" class="survey-intro">{{ introText }}</div>
          <div
            v-for="(child, ci) in visibleNestedList"
            :key="'fs-sv-' + (hotspot.index || 0) + '-' + ci + '-' + (child.index || ci) + '-' + (child.userFieldBind || '')"
            class="survey-field"
          >
            <div class="survey-field__label">
              <span v-if="isFieldRequired(child)" class="survey-field__req">*</span>
              <span v-if="showFieldIndex && displayVisibleIndex(child)">{{ displayVisibleIndex(child) }}. </span>
              <span>{{ fieldTitle(child) }}</span>
            </div>
            <div v-if="fieldHint(child)" class="survey-field__hint">{{ fieldHint(child) }}</div>

            <div
              v-if="isRadioGroup(child)"
              class="survey-radio"
              :class="{ 'survey-radio--list': isListRadio(child) }"
            >
              <div
                v-for="(opt, oi) in host.getUserFormRadioGroupOptions(child)"
                :key="'fs-sv-opt-' + ci + '-' + oi"
                class="survey-radio__opt"
                :class="{ 'is-selected': isScopeRadioGroupSelected(child, opt) }"
                @click.stop="onScopeRadioGroupTap(child, opt)"
              >
                <span v-if="isListRadio(child)" class="survey-radio__dot" />
                <span class="survey-radio__text">{{ opt.label }}</span>
              </div>
            </div>

            <div
              v-else-if="String(child.type) === '16'"
              class="survey-input"
              :class="{
                'survey-input--has-icon': prefixIconOf(child) !== 'none',
                'survey-input--multiline': isMultiline(child)
              }"
            >
              <span
                v-if="prefixIconOf(child) !== 'none'"
                class="survey-input__icon"
                :class="'survey-input__icon--' + prefixIconOf(child)"
              />
              <textarea
                v-if="isMultiline(child)"
                class="survey-input__control survey-input__control--multiline"
                :value="getScopeInputValue(child)"
                :placeholder="host.userFormInputPlaceholder(child)"
                :maxlength="host.userFormInputMaxLength(child)"
                @input="onScopeInput(child, $event)"
              />
              <input
                v-else
                class="survey-input__control"
                :value="getScopeInputValue(child)"
                :placeholder="host.userFormInputPlaceholder(child)"
                :type="host.userFormInputType(child)"
                :maxlength="host.userFormInputMaxLength(child)"
                @input="onScopeInput(child, $event)"
              />
            </div>

            <div
              v-else-if="String(child.type) === '26'"
              class="hotspot-user-form-radio"
              @click.stop="onScopeType26Tap(child)"
            >
              <img
                v-if="isScopeType26Selected(child) && host.getUserFormRadioSelectedImgUrl(child)"
                :src="host.getUserFormRadioSelectedImgUrl(child)"
                class="hotspot-user-form-radio__selected-img"
                :style="host.getUserFormRadioSelectedImgStyle(child)"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 旧：绝对定位热区 -->
      <div v-else class="act004-form-scope__content" :style="contentStyle">
        <img
          v-if="bgUrl"
          class="act004-form-scope__bg"
          :src="bgUrl"
          alt=""
        />
        <div
          v-for="(child, ci) in visibleNestedList"
          :key="'fs-child-' + (hotspot.index || 0) + '-' + ci + '-' + (child.index || ci)"
          class="act004-form-scope__child"
          :style="childBoxStyle(child)"
        >
          <div
            v-if="isRadioGroup(child)"
            class="hotspot-user-form-radio-group"
            :class="{
              'hotspot-user-form-radio-group--column': host.isUserFormRadioGroupColumnLayout(child),
              'survey-radio--list': isListRadio(child)
            }"
            :style="host.getUserFormRadioGroupWrapStyle(child)"
            @click.stop
          >
            <div
              v-for="(opt, oi) in host.getUserFormRadioGroupOptions(child)"
              :key="'fs-frg-' + ci + '-' + oi"
              class="hotspot-user-form-radio-group__opt"
              :class="{ 'is-selected': isScopeRadioGroupSelected(child, opt) }"
              :style="isListRadio(child) ? null : host.getUserFormRadioGroupOptionStyle(child, opt, isScopeRadioGroupSelected(child, opt))"
              @click.stop="onScopeRadioGroupTap(child, opt)"
            >
              <span v-if="isListRadio(child)" class="survey-radio__dot" />
              <span>{{ opt.label }}</span>
            </div>
          </div>
          <div
            v-else-if="String(child.type) === '16'"
            class="hotspot-user-form-input"
            @click.stop
          >
            <img
              v-if="host.getUserFormInputBgUrl(child)"
              :src="host.getUserFormInputBgUrl(child)"
              class="hotspot-image hotspot-user-form-input__bg"
              :style="host.getHotspotUserFormInputBgStyle(child)"
            />
            <textarea
              v-if="isMultiline(child)"
              class="hotspot-user-form-input__control hotspot-user-form-input__control--multiline"
              :value="getScopeInputValue(child)"
              :placeholder="host.userFormInputPlaceholder(child)"
              :maxlength="host.userFormInputMaxLength(child)"
              :style="host.getUserFormInputControlStyle(child)"
              @input="onScopeInput(child, $event)"
            />
            <input
              v-else
              class="hotspot-user-form-input__control"
              :value="getScopeInputValue(child)"
              :placeholder="host.userFormInputPlaceholder(child)"
              :type="host.userFormInputType(child)"
              :maxlength="host.userFormInputMaxLength(child)"
              :style="host.getUserFormInputControlStyle(child)"
              @input="onScopeInput(child, $event)"
            />
          </div>
          <div
            v-else-if="String(child.type) === '26'"
            class="hotspot-user-form-radio"
            @click.stop="onScopeType26Tap(child)"
          >
            <img
              v-if="isScopeType26Selected(child) && host.getUserFormRadioSelectedImgUrl(child)"
              :src="host.getUserFormRadioSelectedImgUrl(child)"
              class="hotspot-user-form-radio__selected-img"
              :style="host.getUserFormRadioSelectedImgStyle(child)"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  isAct004FormRadioGroupBindField,
  normalizeAct004UserFormFieldBind,
  normalizeFormInputRequired,
  normalizeFormInputMultiline,
  normalizeFormInputPrefixIcon,
  normalizeFormRadioUiStyle,
  act004UserFormFieldLabel,
  suggestAct004FormInputLabel,
  resolveAct004RadioShowFieldsVisibility,
  buildAct004VisibleFieldIndexMap
} from '@/utils/act004-user-form-fields'
import {
  normalizeFormScopeKey,
  normalizeFormScopeLayout,
  normalizeFormScopeIntroText,
  normalizeFormScopeShowFieldIndex,
  act004FormScopeDraftKey,
  act004FormScopeFieldBindDraftKey
} from '@/utils/activity-multi/act004-form-scope-hotspot'

export default {
  name: 'Act004FormScopeHotspot',
  props: {
    hotspot: { type: Object, required: true },
    host: { type: Object, required: true }
  },
  computed: {
    scopeKey() {
      return normalizeFormScopeKey(this.hotspot && this.hotspot.formScopeKey) || 'form_scope_1'
    },
    isSurveyLayout() {
      return normalizeFormScopeLayout(this.hotspot && this.hotspot.formScopeLayout) === 'survey'
    },
    introText() {
      return normalizeFormScopeIntroText(this.hotspot && this.hotspot.formScopeIntroText)
    },
    showFieldIndex() {
      return normalizeFormScopeShowFieldIndex(this.hotspot && this.hotspot.formScopeShowFieldIndex) === 1
    },
    viewportW() {
      const n = parseInt(this.hotspot && (this.hotspot.sizeWidth || this.hotspot.size), 10)
      return Number.isFinite(n) && n > 0 ? n : 690
    },
    viewportH() {
      const n = parseInt(this.hotspot && (this.hotspot.sizeHeight || this.hotspot.size), 10)
      return Number.isFinite(n) && n > 0 ? n : 800
    },
    contentH() {
      const n = parseInt(this.hotspot && this.hotspot.formScopeContentHeightRpx, 10)
      const vh = this.viewportH
      return Number.isFinite(n) && n > vh ? n : Math.max(vh, vh * 2)
    },
    nestedList() {
      return Array.isArray(this.hotspot && this.hotspot.formScopeNestedHotspots)
        ? this.hotspot.formScopeNestedHotspots
        : []
    },
    nestedListSorted() {
      return this.nestedList
        .slice()
        .sort((a, b) => {
          const ia = parseInt(a && a.index, 10)
          const ib = parseInt(b && b.index, 10)
          return (Number.isFinite(ia) ? ia : 0) - (Number.isFinite(ib) ? ib : 0)
        })
    },
    /** 单选当前值（按 bind）供 showFields 显隐 */
    radioDraftByBind() {
      const draft = (this.host && this.host.activityUserFormDraft) || {}
      const profile = (this.host && this.host.activityUserFormProfile) || {}
      const out = {}
      this.nestedListSorted.forEach((row) => {
        if (!this.isRadioGroup(row)) return
        const bind = normalizeAct004UserFormFieldBind(row.userFieldBind, '')
        if (!bind) return
        const key = act004FormScopeFieldBindDraftKey(this.scopeKey, bind)
        if (key && Object.prototype.hasOwnProperty.call(draft, key)) {
          out[bind] = draft[key] == null ? '' : String(draft[key])
        } else if (profile[bind] != null) {
          out[bind] = String(profile[bind])
        } else {
          out[bind] = ''
        }
      })
      return out
    },
    showFieldsVisibility() {
      return resolveAct004RadioShowFieldsVisibility(this.nestedListSorted, this.radioDraftByBind)
    },
    visibleNestedList() {
      const vis = new Set(this.showFieldsVisibility.visibleBinds || [])
      return this.nestedListSorted.filter((row) => {
        if (!row || String(row.type) === '26') return true
        const bind = normalizeAct004UserFormFieldBind(row.userFieldBind, '')
        if (!bind) return true
        return vis.has(bind)
      })
    },
    visibleFieldIndexMap() {
      return buildAct004VisibleFieldIndexMap(this.nestedListSorted, this.radioDraftByBind)
    },
    bgUrl() {
      const raw = this.hotspot && this.hotspot.formScopeBgImg
      if (!raw || !this.host || typeof this.host.hotspotAssetUrl !== 'function') return ''
      const u = String(raw).trim()
      return u ? this.host.hotspotAssetUrl(u) : ''
    },
    viewportStyle() {
      return {
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
        boxSizing: 'border-box'
      }
    },
    scrollStyle() {
      return {
        width: '100%',
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        boxSizing: 'border-box'
      }
    },
    contentStyle() {
      const rpx = (n) => (this.host && typeof this.host.rpxPx === 'function' ? this.host.rpxPx(n) : n + 'px')
      return {
        position: 'relative',
        width: '100%',
        height: rpx(this.contentH),
        minHeight: '100%',
        boxSizing: 'border-box'
      }
    },
    surveyContentStyle() {
      const rpx = (n) => (this.host && typeof this.host.rpxPx === 'function' ? this.host.rpxPx(n) : n + 'px')
      return {
        position: 'relative',
        width: '100%',
        minHeight: rpx(this.contentH),
        boxSizing: 'border-box',
        background: this.bgUrl ? 'transparent' : '#fff'
      }
    }
  },
  watch: {
    'showFieldsVisibility.revealedBinds'() {
      this.clearHiddenFieldDrafts()
    }
  },
  methods: {
    isRadioGroup(child) {
      return String(child && child.type) === '16' && isAct004FormRadioGroupBindField(child.userFieldBind)
    },
    isListRadio(child) {
      return normalizeFormRadioUiStyle(child && child.formRadioUiStyle) === 'list'
    },
    isMultiline(child) {
      return normalizeFormInputMultiline(child && child.formInputMultiline, child && child.userFieldBind) === 1
    },
    isFieldRequired(child) {
      return normalizeFormInputRequired(child && child.formInputRequired) === 1
    },
    prefixIconOf(child) {
      return normalizeFormInputPrefixIcon(child && child.formInputPrefixIcon)
    },
    fieldTitle(child) {
      const custom = child && String(child.formInputLabel || '').trim()
      if (custom) return custom
      const bind = normalizeAct004UserFormFieldBind(child && child.userFieldBind, '')
      return suggestAct004FormInputLabel(bind) || act004UserFormFieldLabel(bind) || '填写项'
    },
    fieldHint(child) {
      return child && String(child.formInputHint || '').trim()
    },
    isBindVisible(bind) {
      const b = normalizeAct004UserFormFieldBind(bind, '')
      if (!b) return true
      const vis = this.showFieldsVisibility.visibleBinds || []
      return vis.indexOf(b) >= 0
    },
    displayVisibleIndex(child) {
      const bind = normalizeAct004UserFormFieldBind(child && child.userFieldBind, '')
      const n = this.visibleFieldIndexMap.get(bind)
      return Number.isFinite(n) && n > 0 ? n : ''
    },
    /** 隐藏且未揭示的字段：清空草稿（含曾显示时填入的内容，避免再次显示时残留） */
    clearHiddenFieldDrafts() {
      if (!this.host || !this.host.activityUserFormDraft) return
      const conditional = this.showFieldsVisibility.conditionalBinds || []
      const revealed = new Set(this.showFieldsVisibility.revealedBinds || [])
      conditional.forEach((bind) => {
        if (revealed.has(bind)) return
        this.nestedListSorted.forEach((row) => {
          if (!row || normalizeAct004UserFormFieldBind(row.userFieldBind, '') !== bind) return
          const key = act004FormScopeDraftKey(this.scopeKey, row)
          if (key) this.host.$set(this.host.activityUserFormDraft, key, '')
        })
        const bindKey = act004FormScopeFieldBindDraftKey(this.scopeKey, bind)
        if (bindKey) this.host.$set(this.host.activityUserFormDraft, bindKey, '')
      })
    },
    childBoxStyle(child) {
      const rpx = (n) => (this.host && typeof this.host.rpxPx === 'function' ? this.host.rpxPx(n) : n + 'px')
      const leftPct = Number(child && child.left) || 0
      const topPct = Number(child && child.top) || 0
      const w = parseInt(child && (child.sizeWidth || child.size), 10) || 600
      const h = parseInt(child && (child.sizeHeight || child.size), 10) || 80
      const leftRpx = (leftPct / 100) * this.viewportW - w / 2
      const topRpx = (topPct / 100) * this.contentH - h / 2
      return {
        position: 'absolute',
        left: rpx(leftRpx),
        top: rpx(topRpx),
        width: rpx(w),
        height: rpx(h),
        boxSizing: 'border-box'
      }
    },
    getScopeInputValue(child) {
      const draft = (this.host && this.host.activityUserFormDraft) || {}
      const key = act004FormScopeDraftKey(this.scopeKey, child)
      if (Object.prototype.hasOwnProperty.call(draft, key)) {
        return draft[key] == null ? '' : String(draft[key])
      }
      const bind = String(child && child.userFieldBind || '').trim()
      const profile = (this.host && this.host.activityUserFormProfile) || {}
      return profile[bind] != null ? String(profile[bind]) : ''
    },
    onScopeInput(child, e) {
      let val = e && e.target ? e.target.value : ''
      const maxLen = this.host.userFormInputMaxLength(child)
      if (val.length > maxLen) {
        val = val.slice(0, maxLen)
        if (e && e.target) e.target.value = val
      }
      const key = act004FormScopeDraftKey(this.scopeKey, child)
      this.host.$set(this.host.activityUserFormDraft, key, val)
    },
    getScopeFieldValue(bind) {
      const draft = (this.host && this.host.activityUserFormDraft) || {}
      const key = act004FormScopeFieldBindDraftKey(this.scopeKey, bind)
      if (key && Object.prototype.hasOwnProperty.call(draft, key)) {
        return draft[key] == null ? '' : String(draft[key])
      }
      const profile = (this.host && this.host.activityUserFormProfile) || {}
      const b = String(bind || '').trim()
      return profile[b] != null ? String(profile[b]) : ''
    },
    isScopeRadioGroupSelected(child, opt) {
      const bind = normalizeAct004UserFormFieldBind(child && child.userFieldBind, '')
      const selected = String(this.getScopeFieldValue(bind) || '').trim()
      if (!selected) return false
      const label = this.host.resolveUserFormRadioGroupPersistText(opt)
      if (label && selected === label) return true
      const val = String(opt && opt.value != null ? opt.value : '').trim()
      return !!(val && selected === val)
    },
    onScopeRadioGroupTap(child, opt) {
      const bind = normalizeAct004UserFormFieldBind(child && child.userFieldBind, '')
      const text = this.host.resolveUserFormRadioGroupPersistText(opt)
      if (!bind || !text) return
      const key = act004FormScopeFieldBindDraftKey(this.scopeKey, bind)
      this.host.$set(this.host.activityUserFormDraft, key, text)
      this.$nextTick(() => this.clearHiddenFieldDrafts())
    },
    isScopeType26Selected(child) {
      const bind = this.host.resolveAct004FormRadioBind(child, 'channel')
      const selected = this.getScopeFieldValue(bind)
      const opt = String(child && child.formRadioOptionValue || '').trim()
      return !!(opt && selected === opt)
    },
    onScopeType26Tap(child) {
      const bind = this.host.resolveAct004FormRadioBind(child, 'channel')
      const val = String(child && child.formRadioOptionValue || '').trim()
      if (!bind || !val) return
      const key = act004FormScopeFieldBindDraftKey(this.scopeKey, bind)
      this.host.$set(this.host.activityUserFormDraft, key, val)
    }
  }
}
</script>

<style scoped>
.act004-form-scope {
  z-index: 2;
}
.act004-form-scope--survey {
  background: #fff;
}
.act004-form-scope__bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  z-index: 0;
}
.act004-form-scope__bg--survey {
  object-fit: fill;
  opacity: 0.35;
}
.act004-form-scope__child {
  z-index: 1;
}
.act004-form-scope__survey-inner {
  position: relative;
  z-index: 1;
  padding: 28rpx 32rpx 48rpx;
  box-sizing: border-box;
}
.survey-intro {
  font-size: 28rpx;
  line-height: 1.55;
  color: #303133;
  margin-bottom: 36rpx;
}
.survey-field {
  margin-bottom: 36rpx;
}
.survey-field__label {
  font-size: 30rpx;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.4;
  margin-bottom: 12rpx;
}
.survey-field__req {
  color: #f56c6c;
  margin-right: 4rpx;
}
.survey-field__hint {
  font-size: 24rpx;
  color: #909399;
  line-height: 1.45;
  margin: -4rpx 0 14rpx;
}
.survey-input {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 80rpx;
  border: 1px solid #dcdfe6;
  border-radius: 8rpx;
  background: #fff;
  box-sizing: border-box;
  padding: 0 20rpx;
}
.survey-input--has-icon {
  padding-left: 12rpx;
}
.survey-input__icon {
  flex-shrink: 0;
  width: 36rpx;
  height: 36rpx;
  margin-right: 12rpx;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.45;
}
.survey-input__icon--user {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23909399'%3E%3Cpath d='M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z'/%3E%3C/svg%3E");
}
.survey-input__icon--phone {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23909399'%3E%3Cpath d='M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z'/%3E%3C/svg%3E");
}
.survey-input__control {
  flex: 1;
  min-width: 0;
  height: 80rpx;
  border: none;
  outline: none;
  background: transparent;
  font-size: 28rpx;
  color: #303133;
  box-sizing: border-box;
}
.survey-input__control::placeholder {
  color: rgba(0, 0, 0, 0.28);
}
.survey-radio--list {
  border: 1px solid #dcdfe6;
  border-radius: 8rpx;
  background: #fff;
  overflow: hidden;
}
.survey-radio--list .survey-radio__opt,
.survey-radio--list .hotspot-user-form-radio-group__opt {
  display: flex;
  align-items: center;
  gap: 16rpx;
  min-height: 88rpx;
  padding: 0 24rpx;
  box-sizing: border-box;
  border-bottom: 1px solid #ebeef5;
  font-size: 28rpx;
  color: #303133;
  cursor: pointer;
}
.survey-radio--list .survey-radio__opt:last-child,
.survey-radio--list .hotspot-user-form-radio-group__opt:last-child {
  border-bottom: none;
}
.survey-radio--list .survey-radio__opt.is-selected,
.survey-radio--list .hotspot-user-form-radio-group__opt.is-selected {
  background: #fafafa;
}
.survey-radio__dot {
  width: 32rpx;
  height: 32rpx;
  border-radius: 50%;
  border: 2rpx solid #c0c4cc;
  box-sizing: border-box;
  flex-shrink: 0;
  position: relative;
}
.survey-radio__opt.is-selected .survey-radio__dot,
.hotspot-user-form-radio-group__opt.is-selected .survey-radio__dot {
  border-color: #409eff;
}
.survey-radio__opt.is-selected .survey-radio__dot::after,
.hotspot-user-form-radio-group__opt.is-selected .survey-radio__dot::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 16rpx;
  height: 16rpx;
  margin: -8rpx 0 0 -8rpx;
  border-radius: 50%;
  background: #409eff;
}

/* 旧热区样式 */
.hotspot-user-form-radio-group {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  box-sizing: border-box;
}
.hotspot-user-form-radio-group.survey-radio--list {
  position: relative;
  height: auto;
  min-height: 100%;
}
.hotspot-user-form-radio-group__opt {
  border-radius: 6px;
  transition: color 0.15s ease, background-color 0.15s ease;
}
.hotspot-user-form-radio-group__opt.is-selected {
  background: rgba(255, 255, 255, 0.55);
}
.hotspot-user-form-radio {
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: transparent;
  pointer-events: auto;
  z-index: 2;
}
.hotspot-user-form-radio__selected-img {
  display: block;
  flex-shrink: 0;
  pointer-events: none;
  object-fit: contain;
}
.hotspot-user-form-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 2;
}
.hotspot-user-form-input__bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  pointer-events: none;
  z-index: 0;
}
.hotspot-user-form-input__control {
  position: relative;
  z-index: 1;
  flex: 1;
  width: 100%;
  min-width: 0;
  margin: 0;
  border: none;
  outline: none;
  box-shadow: none;
  -webkit-appearance: none;
  appearance: none;
  box-sizing: border-box;
  background: transparent;
  color: #333;
  text-align: left;
  vertical-align: middle;
}
.hotspot-user-form-input__control::placeholder {
  color: rgba(0, 0, 0, 0.35);
}
.hotspot-user-form-input__control:focus {
  outline: none;
}

.survey-input--multiline {
  align-items: flex-start;
  min-height: 160rpx;
}
.survey-input__control--multiline {
  min-height: 120rpx;
  height: auto;
  padding-top: 16rpx;
  padding-bottom: 16rpx;
  line-height: 1.45;
  resize: none;
  white-space: pre-wrap;
  word-break: break-word;
}
.hotspot-user-form-input__control--multiline {
  display: block;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  resize: none;
}
</style>
